export const makenqyzy = {
    id: "makenqyzy",
    name: { ru: "Макенқызы Ақерке", kz: "Макенқызы Ақерке" },
    position: { ru: "Врач-офтальмолог (взрослый и детский)", kz: "Ересектер мен балалар офтальмолог дәрігері" },
    department: "specialists",
    image: "/team_photoes/new/Макенқызы Ақерке.svg",
    experience: {
      ru: "7 лет",
      kz: "7 жыл"
    },
    education: {
      ru: `2017–2020 — Резидентура по офтальмологии, НАО «Медицинский университет Астана»
2022–настоящее время — Докторантура по специальности «Медицина», НАО МУА`,
      kz: `2017–2020 — Офтальмология бойынша резидентура, «Астана медициналық университеті» АҚ
2022–қазіргі уақыт — «Медицина» мамандығы бойынша докторантура, АМУ АҚ`
    },
    specialization: {
      ru: `Диагностика и лечение заболеваний глаз у взрослых и детей
Профилактика и лечение нарушений зрения
Спортивная офтальмология
Рефракционная хирургия`,
      kz: `Ересектер мен балалардың көз ауруларын диагностикалау және емдеу
Көру қабілетінің бұзылуын алдын алу және емдеу
Спорттық офтальмология
Рефракциялық хирургия`
    },
        work: {
    ru: `• 2010–2015 — Государственный медицинский университет г. Семей, бакалавр медицины
• 2015–2017 — Государственный медицинский университет г. Семей, интернатура по специальности «Хирургия»
• 2020–2024 — Врач-офтальмолог, клиники Sana Vita и Аланда
• 2022–наст. время — Врач-офтальмолог, Спортивный медицинский центр
• 2024–наст. время — Врач-офтальмолог, Otbasy clinic (взрослый и детский прием)
• 2025 г. — по настоящее время — Ассистент кафедры глазных болезней "НАО МУА"`,
    kz: `• 2010–2015 — Семей мемлекеттік медицина университеті, медицина бакалавры
• 2015–2017 — Семей мемлекеттік медицина университеті, «Хирургия» мамандығы бойынша интернатура
• 2020–2024 — Офтальмолог дәрігері, Sana Vita және Аланда клиникалары
• 2022–қазіргі уақыт — Офтальмолог дәрігері, Спорттық медициналық орталық
• 2024–қазіргі уақыт — Офтальмолог дәрігері, Otbasy clinic (ересек және бала қабылдауы)
• 2025 ж. — қазіргі уақытқа дейін — "НАО МУА" көз аурулары кафедрасының ассистенті`
  },
certificates: {
    ru: `Научная и практическая деятельность:
Автор научного доклада: «Спорттық белсенділік пен жетістіктерге әсер ететін көз жарақаттары»

Автор и соавтор научных публикаций:
- COMPARATIVE EVALUATION OF PAIN SYNDROME OF OPERATED PATIENTS WITH INGUINAL HERNIAS — Science & Healthcare, 2016
- Computed Tomography Dacryocystography in the Diagnosis of Chronic Epiphora — (JAMA Ophthalmology, рецензируется)
- Exploring clinical, pathogenetic and diagnostic dimensions of nasolacrimal drainage system pathologies — Science & Healthcare, 2024
- Тезис: «Роль мультидетекторной КТ-инстилляционной дакриоцистографии в диагностике обструкций слезоотводящей системы» — Астана медициналық журнал`,
    kz: '',
  }
  };
